module.exports = __webpack_public_path__ + "static/media/web-secure-logo.01583ba1.png";